export default {
    loading: false,
    tab: 'form',
    value: null,
}